import React from "react";
import "./Intro.css";

const Intro = () => {
  return (
    <section className="intro">
      <div className="intro-container">
        <h2>
          Welcome To <span>Eaver</span>
        </h2>
        <p>
          Eaver has been a leading supplier of HT & LT products for over many
          years.
        </p>
        <p>
          <b>
            We pledge what we vend, our products are high-quality and reliable
            ones and are bound to surpass all International standards.
          </b>
        </p>
      </div>
    </section>
  );
};

export default Intro;
